import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar_old";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("⚠️ Email aur Password dono zaroori hain!");
      return;
    }

    try {
      const res = await axios.post("https://rishtey.rishteymatch.in/api2/login", {
        email,
        password,
      });

      if (res.data.success) {
        const user = res.data.user;

        // ✅ Clear old storage
        localStorage.clear();
        sessionStorage.clear();

        // ✅ Save user info & token consistently
        localStorage.setItem("currentUser", JSON.stringify(user));

        alert(`🎉 Welcome ${user.full_name || user.name}! Login Successful.`);
        navigate("/home", { replace: true });

        // Optional: reload after redirect
        setTimeout(() => window.location.reload(), 400);
      } else {
        alert(res.data.message || "❌ Invalid email or password!");
      }
    } catch (err) {
      console.error("Server Error:", err);
      alert("🚨 Server not responding. Please try again later.");
    }
  };

  return (
    <>
      <Navbar />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(315deg, rgb(121 0 33 / 82%), rgb(212, 108, 70))",
          padding: "20px",
        }}
      >
        <div
          className="card p-4 shadow-lg"
          style={{
            maxWidth: "400px",
            width: "100%",
            borderRadius: "16px",
            background:
              "linear-gradient(315deg, rgba(172,119,41,0.9), rgba(195,94,57,0.9))",
            color: "white",
          }}
        >
          <h2 className="text-center mb-4">Login</h2>
          <form onSubmit={handleLogin} className="d-flex flex-column">
            <label className="mb-1">Email</label>
            <input
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control mb-3"
              style={{ borderRadius: "8px" }}
              required
            />

            <label className="mb-1">Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control mb-4"
              style={{ borderRadius: "8px" }}
              required
            />

            <button
              type="submit"
              className="btn btn-success fw-bold"
              style={{ borderRadius: "8px", padding: "10px" }}
            >
              Login
            </button>
          </form>

          <div className="text-center mt-3">
            <small>
              Don't have an account?{" "}
              <a
                href="/register"
                className="text-warning text-decoration-none"
              >
                Register
              </a>
            </small>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
